import "./Case.css"
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import InfoBox from "../Components/UI/InfoBox";
import info from "../Components/images/info.png";
import windmills from "../Components/images/windmills.png";
import { Trans, useTranslation } from "react-i18next";

function CasePage (props) {
    const { t } = useTranslation();
    
    // Navigate with Button
    const navigate = useNavigate();
    function navigateHandler () {
        navigate("/1");
    }

    const orders = props.orders;

    //Infobox
    const [boxStyle, setBoxStyle] = useState({display: "none"});
    const [buttonStyle, setButtonStyle] = useState({display: ""});
    function showInfoBox() {
        setBoxStyle({display: ""});
        setButtonStyle({display: "none"});
    }

    function hideInfoBox() {
        setBoxStyle({display: "none"});
        setButtonStyle({display: ""});
    }

    const currentDate = new Date().toLocaleDateString()

    return (
        <div className="container-md case">
            <Trans values={{currentDate: currentDate}}>
            <h1>10 Task Planning Challenge</h1>
            <h2>{t("case_description")}:</h2>
            <div className="row m-0" style={{display: "flex", alignItems: "center"}}>
                <div className="col-sm-4 m-auto" style={{maxWidth: 300}}>
                    <img className="img-fluid" src={windmills} alt="windmills" />
                </div>
                <p className="col-sm p-0 m-0">{t("caseDescriptionText1")}</p>
            </div>
            <p>{t("caseDescriptionText2")}</p>
            <p><span>{t("rule")} 1:</span> {t("rule1")}</p>
            <p><span>{t("rule")} 2:</span> {t("setup_time")}</p>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>{t("from_color")}</th>
                        <th>{t("to_color")}</th>
                        <th>{t("duration")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></td>
                        <td><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></td>
                        <td>12 {t("hours")}</td>
                    </tr>
                    <tr>
                        <td><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></td>
                        <td><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></td>
                        <td>4 {t("hours")}</td>
                    </tr>
                    <tr>
                        <td><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></td>
                        <td><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></td>
                        <td>8 {t("hours")}</td>
                    </tr>
                    <tr>
                        <td>*</td>
                        <td>*</td>
                        <td>0 {t("hours")}</td>
                    </tr>
                </tbody>
            </table>
            <p>{t("example")}</p>
            <p>
                {t("width_depends")} <br/>
                <mark>{t("width_formula")}</mark>
            </p>
            <p>
                {t("score_measuring")} <br/>
                <mark>{t("score_formula")}</mark>
            </p>
            <p>{t("penalty_text")}</p>
            </Trans>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>{t("orderNr")}</th>
                        <th>{t("width")}</th>
                        <th>{t("color")}</th>
                        <th>{t("dueDate")}</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order) => (
                        <tr key={order.orderNr}>
                            <td>{order.orderNr}</td>
                            <td>{order.width}</td>
                            {order.color.props.children === "Blau" ? <td><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></td> 
                                : order.color.props.children === "Violett" ? <td><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></td> 
                                : <td><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></td>}
                            <td>{order.dueDate}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button onClick={showInfoBox} className="infoButton" style={buttonStyle}><img src={info} width={25} height={25} alt="info"/></button>
            <InfoBox style={boxStyle} hideInfoBox={hideInfoBox}></InfoBox>
            <p><br/>{t("if_ready_text")}</p>
            <div className="button-div">
                <button onClick={navigateHandler} type="button" className="button">{t("lets_start")}</button>
            </div>
        </div>
    );
};

export default CasePage;